import * as moment from 'moment';

export class Usergroups {
    id	: number;
    name	: string;
    created	: moment.Moment;
    updated	: moment.Moment;
    accountId	: number;
}
